// extracted by mini-css-extract-plugin
export default {"wrap":"ProjectsList_wrap__nprng","list":"ProjectsList_list__G0ury","grid":"ProjectsList_grid__+IDE+"};